import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  Section,
  SectionInner,
  SectionHead,
  SectionHeading,
} from "../../globalStyles";

const Grid = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-8) var(--space-6);

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: var(--space-6);
  }
`;

/* 말풍선 카드. 꼬리는 왼쪽 아래. */
const Bubble = styled.li`
  position: relative;
  padding: var(--space-6) var(--space-6) var(--space-7, 28px);
  border: 2px solid var(--text-primary);
  border-radius: var(--radius-lg);
  background: #ffffff;
  box-shadow: 4px 4px 0 var(--text-primary);

  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 28px;
    bottom: -14px;
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 14px solid var(--text-primary);
  }

  &::after {
    bottom: -10px;
    left: 30px;
    border-left-width: 10px;
    border-right-width: 10px;
    border-top: 12px solid #ffffff;
  }
`;

const Title = styled.h3`
  font-size: 1.125rem;
  font-weight: var(--font-weight-extrabold);
  letter-spacing: -0.02em;
  color: var(--text-primary);
  line-height: 1.4;
  word-break: keep-all;
  text-wrap: pretty;
`;

const Note = styled.p`
  margin-top: var(--space-3);
  font-size: 0.875rem;
  font-weight: var(--font-weight-semibold);
  color: var(--text-muted);
`;

const CultureSection = () => {
  const [language, setLanguage] = useState("ko");
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/en") setLanguage("en");
    else if (location.pathname === "/ko") setLanguage("ko");
    else setLanguage(localStorage.getItem("language") || "ko");

    const handleLanguageChange = (e) => setLanguage(e.detail);
    window.addEventListener("languageChange", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChange", handleLanguageChange);
  }, [location.pathname]);

  const content = {
    ko: {
      heading: "바삭한소프트의 일하는 방식",
      cards: [
        { title: "Peer Review 및 피드백 (바삭설문)", note: "분기별 1회 시행" },
        { title: "수평적인 관계, 수직적인 의사결정" },
        { title: "많은 자율성과 많은 책임" },
        { title: "데이터 기반 의사결정" },
        { title: "애자일한 게임 개발" },
        { title: "기술 기반 혁신" },
      ],
    },
    en: {
      heading: "How we work at Basakansoft",
      cards: [
        { title: "Peer review & feedback (Basak Survey)", note: "Once a quarter" },
        { title: "Flat relationships, decisive decisions" },
        { title: "High autonomy, high accountability" },
        { title: "Data-driven decisions" },
        { title: "Agile game development" },
        { title: "Technology-driven innovation" },
      ],
    },
  };

  const c = content[language];

  return (
    <Section id="culture" $rule>
      <SectionInner>
        <SectionHead>
          <SectionHeading>{c.heading}</SectionHeading>
        </SectionHead>
        <Grid>
          {c.cards.map((card, i) => (
            <Bubble key={i}>
              <Title>{card.title}</Title>
              {card.note && <Note>{card.note}</Note>}
            </Bubble>
          ))}
        </Grid>
      </SectionInner>
    </Section>
  );
};

export default CultureSection;
